// Auto-generated by scripts/build-dicts.mjs — DO NOT EDIT
// Strategy: one-chunk-per-atom — 10 non-empty atoms, 10 chunks
// Atom→chunk: A→0, B→1, AB→2, ABC→3, D→4, AD→5, BD→6, ABD→7, ACD→8, ABCD→9

import { BiDirectionalDictionary } from '../dict';
import { CHUNK_0_WORDS } from './chunk-0';
import { CHUNK_1_WORDS } from './chunk-1';
import { CHUNK_2_WORDS } from './chunk-2';
import { CHUNK_3_WORDS } from './chunk-3';
import { CHUNK_4_WORDS } from './chunk-4';
import { CHUNK_5_WORDS } from './chunk-5';
import { CHUNK_6_WORDS } from './chunk-6';
import { CHUNK_7_WORDS } from './chunk-7';
import { CHUNK_8_WORDS } from './chunk-8';
import { CHUNK_9_WORDS } from './chunk-9';

// DICT_MAP: SowpodsDictionary ← chunks [0,2,3,5,7,8,9]
// DICT_MAP: Csw22Dictionary ← chunks [1,2,3,6,7,9]
// DICT_MAP: Twl06Dictionary ← chunks [3,8,9]
// DICT_MAP: Wow24Dictionary ← chunks [4,5,6,7,8,9]

export const SowpodsDictionary = new BiDirectionalDictionary()
    .loadCompiled(CHUNK_0_WORDS)
    .loadCompiled(CHUNK_2_WORDS)
    .loadCompiled(CHUNK_3_WORDS)
    .loadCompiled(CHUNK_5_WORDS)
    .loadCompiled(CHUNK_7_WORDS)
    .loadCompiled(CHUNK_8_WORDS)
    .loadCompiled(CHUNK_9_WORDS)
;

export const Csw22Dictionary = new BiDirectionalDictionary()
    .loadCompiled(CHUNK_1_WORDS)
    .loadCompiled(CHUNK_2_WORDS)
    .loadCompiled(CHUNK_3_WORDS)
    .loadCompiled(CHUNK_6_WORDS)
    .loadCompiled(CHUNK_7_WORDS)
    .loadCompiled(CHUNK_9_WORDS)
;

export const Twl06Dictionary = new BiDirectionalDictionary()
    .loadCompiled(CHUNK_3_WORDS)
    .loadCompiled(CHUNK_8_WORDS)
    .loadCompiled(CHUNK_9_WORDS)
;

export const Wow24Dictionary = new BiDirectionalDictionary()
    .loadCompiled(CHUNK_4_WORDS)
    .loadCompiled(CHUNK_5_WORDS)
    .loadCompiled(CHUNK_6_WORDS)
    .loadCompiled(CHUNK_7_WORDS)
    .loadCompiled(CHUNK_8_WORDS)
    .loadCompiled(CHUNK_9_WORDS)
;
